module.exports = __webpack_public_path__ + "img/logo_celeiro.4a6d995a.svg";